module.exports = __webpack_public_path__ + "static/bag-c26fbb88b94c8637646e49b5fae360f5.jpg";